<template>
  <div class="panel-contanier">
    <div class="top" :style="{'height': height}">
      <svg-icon iconClass="panel-icon" className="icon" :style="{'font-size': height}" />
      <span v-if="title" :style="{'height': height, 'font-size': fontSize, 'line-height': height}">{{ title }}</span>
      <slot v-else name="header"></slot>
    </div>
    <div class="panel-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        height: {
           type: String,
           default: '24px'
        },
        fontSize: {
           type: String,
           default: '18px'
        }
    }
}
</script>

<style lang="less" scoped>
.panel-contanier{
    width: calc(100% - 80px);
    margin: 0 auto;
    height: auto;
    .top {
        display: flex;
        align-items: center;
        width: 100%;
        height: 24px;
        display: flex;
        color: rgba(35, 149, 243, 1);
        .icon {
            font-size: 24px;
        }
        span {
            width: auto;
            height: 24px;
            color: #25396F;
            font-size: 18px;
            font-weight: 400;
            line-height: 24px;
            margin-left: 16px;
        }
    }
    .panel-content {
        width: 100%;
        height: auto;
        margin-top: 20px;
    }
}
</style>
